export default "__VITE_ASSET__D$K1RX95__"